export default ({
  fieldName,
  field,
  meta,
  forceErrorStyles,
  onChange = Function.prototype,
  onBlur = Function.prototype,
  onKeyDown = Function.prototype,
}) => {
  const fieldOnChange = field.onChange;
  const handleChange = newValue => {
    fieldOnChange({
      target: {
        value: newValue,
        name: fieldName,
      },
    });
    onChange(newValue, field.value);
  };

  const fieldKeyDown = field.onKeyDown;
  const handleOnKeyDown = newValue => {
    fieldKeyDown({
      target: {
        value: newValue,
        name: fieldName,
      },
    });
    onKeyDown(newValue, fieldName);
  };

  const handleBlur = newValue => {
    // call formik handleBlur method
    field.onBlur({
      target: {
        value: newValue,
        name: fieldName,
      },
    });
    setTimeout(() => onBlur(newValue, field.value), 0);
  };

  return {
    ...field,
    onBlur: handleBlur,
    onChange: handleChange,
    onKeyDown: handleOnKeyDown,
    hasError: Boolean((meta.touched && meta.error) || forceErrorStyles),
  };
};
